const initialState = {
  user: {},
  users: [],
};

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case "SET_USER":
      return {
        ...state,
        user: action.payload,
      };
    case "SET_AGENT":
      return {
        ...state,
        user: action.payload,
      };
    case "FETCH_USERS":
      return {
        ...state,
        users: action.payload,
      };
    default:
      return state;
  }
};
